export const ORGANIZATION_STORAGE_KEYS = {
  organizations: "organizations",
  activeOrganization: "activeOrganization",
  currentUser: "currentUser",
};

const safeParse = (value, fallback) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
};

const notifyOrganizationChange = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("zarp:organization-change"));
  }
};

export const getStoredOrganizations = () =>
  safeParse(localStorage.getItem(ORGANIZATION_STORAGE_KEYS.organizations), []);

export const getActiveOrganization = () =>
  safeParse(localStorage.getItem(ORGANIZATION_STORAGE_KEYS.activeOrganization), null);

export const setOrganizations = (organizations = [], options = {}) => {
  localStorage.setItem(ORGANIZATION_STORAGE_KEYS.organizations, JSON.stringify(organizations));
  if (!options.silent) {
    notifyOrganizationChange();
  }
};

export const setCurrentUser = (user) => {
  if (user) {
    localStorage.setItem(ORGANIZATION_STORAGE_KEYS.currentUser, JSON.stringify(user));
  }
};

export const setActiveOrganization = (organization, options = {}) => {
  if (!organization) {
    localStorage.removeItem(ORGANIZATION_STORAGE_KEYS.activeOrganization);
    if (!options.silent) {
      notifyOrganizationChange();
    }
    return null;
  }

  localStorage.setItem(ORGANIZATION_STORAGE_KEYS.activeOrganization, JSON.stringify(organization));
  if (!options.silent) {
    notifyOrganizationChange();
  }
  return organization;
};

export const getOrganizationIdentity = (organization) => {
  if (!organization) return "";
  return String(organization.organizationKey || organization.id || "");
};

export const selectDefaultOrganization = (organizations = []) => {
  if (!Array.isArray(organizations) || organizations.length === 0) {
    setActiveOrganization(null);
    return null;
  }

  const current = getActiveOrganization();
  const currentIdentity = getOrganizationIdentity(current);
  const stillAllowed = current
    ? organizations.find((organization) => getOrganizationIdentity(organization) === currentIdentity)
    : null;
  const next = stillAllowed || organizations.find((organization) => organization.isDefault) || organizations[0];
  return setActiveOrganization(next);
};

export const getActiveOrganizationHeaderValue = () => {
  const organizations = getStoredOrganizations();
  const current = getActiveOrganization();

  if (organizations.length > 0) {
    const currentIdentity = getOrganizationIdentity(current);
    const allowedOrganization = organizations.find(
      (organization) => getOrganizationIdentity(organization) === currentIdentity,
    );
    const organization = allowedOrganization || organizations.find((item) => item.isDefault) || organizations[0];
    if (organization && organization !== current) {
      setActiveOrganization(organization);
    }
    return organization?.organizationKey || organization?.id || "";
  }

  const organization = current;
  return organization?.organizationKey || organization?.id || "";
};

export const clearOrganizationSession = () => {
  Object.values(ORGANIZATION_STORAGE_KEYS).forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
  notifyOrganizationChange();
};
